export const ITEM_PREFIXES = {
    default: '~main',
    pinTop: '~pinTop',
    pinBottom: '~pinBottom',
    footer: '~footer',
    search: '~search',
    dropFocus: '~dropFocus',
};
